import React from 'react';
import { MdEmojiEvents } from 'react-icons/md';
import Tooltip from '@srm/ui/tooltip';
import { renderWinnersTooltipContent } from './winnersTooltipContent';

/**
 * Чип «Победитель: …» или мульти-вариант «🏆 [N] Победители: имя1 · имя2 · …»
 * с aurora counter-badge и fade-mask на правом крае.
 *
 * Скрывает себя если winnerNames пуст.
 */
export const WinnerNamesChip: React.FC<{ winnerNames: string[] }> = ({ winnerNames }) => {
    if (winnerNames.length === 0) return null;

    if (winnerNames.length === 1) {
        return (
            <span className="ws-pos-head__meta-chip ws-pos-head__meta-chip--winner">
                <MdEmojiEvents size="14px" />
                <b>{winnerNames[0]}</b>
            </span>
        );
    }

    return (
        <Tooltip
            background="black"
            wrapTarget={false}
            interactive={false}
            openDelay={250}
            position="bottom"
            label={renderWinnersTooltipContent(winnerNames)}
        >
            <span className="ws-pos-head__meta-chip ws-pos-head__meta-chip--winner ws-pos-head__meta-chip--multi-winner">
                <MdEmojiEvents size="14px" />
                <span className="ws-pos-head__winner-count" aria-label={`${winnerNames.length} победителей`}>
                    {winnerNames.length}
                </span>
                <b className="ws-pos-head__winner-list">
                    {winnerNames.map((name, i) => (
                        <React.Fragment key={`${i}-${name}`}>
                            {i > 0 && (
                                <span className="ws-pos-head__winner-sep" aria-hidden>
                                    ·
                                </span>
                            )}
                            <span className="ws-pos-head__winner-name">{name}</span>
                        </React.Fragment>
                    ))}
                </b>
            </span>
        </Tooltip>
    );
};
